// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueCookie from 'vue-cookie'
import router from './router'
import headerBlock from './components/include/header'
import footerBlock from './components/include/footer'
import modalsBlock from './components/include/modals'
import axios from '@/router/http'
import Clipboard from 'v-clipboard'

import moment from 'moment'
Vue.prototype.$moment = moment

Vue.config.productionTip = false
Vue.use(VueCookie)
Vue.use(VueMeta, {refreshOnceOnNavigation: true})
Vue.use(Clipboard)
Vue.component('header-block', headerBlock)
Vue.component('footer-block', footerBlock)
Vue.component('modals-block', modalsBlock)
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data () {
    return {
      user: {
        uid: null
      },
      requestModal: 0,
      requestModalText: '',
      requestModalId: '',
      requestModalTime: '',
      requestModalPrice: 350,
      outsideModal: -1
    }
  },
  created () {
    var hostname = window.location.hostname
    var hostnameforcookie
    if (hostname !== 'localhost') {
      hostname = hostname.split('.')
      if (hostname.length === 3) hostnameforcookie = hostname[1] + '.' + hostname[2]
      else hostnameforcookie = hostname[0] + '.' + hostname[1]
    } else {
      hostnameforcookie = 'localhost'
      hostname = 'localhost'
    }
    if (this.$route.query.gcpc) this.$cookie.set('gcpc', this.$route.query.gcpc, {expires: '1Y', domain: hostnameforcookie})

    let uid = this.$cookie.get('uid')
    if (uid) this.user.uid = uid
    if (!this.user.uid) {
      let link
      if (this.$route.name === 'referal' && this.$route.params.id) link = 'https://urist2.v-avtoservice.com/list/create-uid?invite=' + this.$route.params.id
      else link = 'https://urist2.v-avtoservice.com/list/create-uid'
      axios.get(link, {
        crossDomain: true,
        headers: {'Access-Control-Allow-Origin': '*'}
      }).then(response => {
        this.user.uid = response.data.uid
        this.$cookie.set('uid', this.user.uid, {expires: '1Y', domain: hostnameforcookie})
      })
    } else {
      axios.get('https://urist2.v-avtoservice.com/list/get-uid?uid=' + this.user.uid).then(response => {
        this.user = response.data.user
      })
    }
  },
  mounted () {
    this.closeTabs()
  },
  methods: {
    hideModal () {
      this.outsideModal++
    },
    closeTabs () {
      $(document).mouseleave(function (e) {
        let checkModal = document.getElementsByClassName('form__btn-wrapper')
        if ((e.clientY < 100000) && checkModal.length === 0) {
          $('.exitblock').fadeIn('fast').trigger('click')
          $('.exitblock').is(':visible')
          $('.exitblock').remove()
        }
        return null
      })
    }
  },
  watch: {
    outsideModal (val) {
      if (val > 0) {
        this.outsideModal = -1
        this.requestModal = 0
      }
    },
    requestModal (val, old) {
      if (val !== old || val === 0) {
        this.outsideModal = -1
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js